import React, { useMemo } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import ButtonAceptar from './ButtonAceptar'
import IconCloseModal from './IconCloseModal'


type PropsModalMensaje = {
    show: boolean,
    size: "xl" | "sm" | "md" | "lg",
    onClose: () => void,
    tituloModal: string,
    mensaje: string,
    mensajeHtml?: React.ReactElement | undefined
    centered: boolean
    hideButton?: boolean
}

export default function ModalMensaje(props: PropsModalMensaje) {



    const BotonCerrar = useMemo(() => {


        return (
            <IconCloseModal
                handleClickIcon={() => props.onClose()}
            />
        )
    }
        , [props])


    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={props.centered}
            onClosed={() => props.onClose()}
        // contentClassName="custom-modal-style"
        >
            <ModalHeader close={BotonCerrar}>
                <div className='tituloModalDocumentos'>{props.tituloModal}</div>
            </ModalHeader>
            <ModalBody>
                {
                    props.mensajeHtml !== undefined &&
                    props.mensajeHtml
                }
                {
                    props.mensajeHtml === undefined &&
                    <div>
                        {props.mensaje}
                    </div>
                }

            </ModalBody>
            <ModalFooter>
                {
                    props.hideButton === undefined || (props.hideButton !== undefined && props.hideButton === false) &&
                    <ButtonAceptar
                        handleClickAceptar={() => props.onClose()}

                    />
                }

            </ModalFooter>
        </Modal>
    )
}
